import { useCallback, useEffect, useRef } from 'react';

export const useInactivityTracker = ({ onInactive, timeout = 120000 }: { onInactive: () => void; timeout: number }) => {
  const timer = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = useCallback(() => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      onInactive();
    }, timeout);
  }, [onInactive, timeout]);

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach((event) => window.addEventListener(event, resetTimer, { passive: true }));
    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [resetTimer]);

  return { resetInactivityTimer: resetTimer };
};
